<script setup lang="ts">
/**
 * Wrapper local autour de #campaign-ui/CampaignDonorsBanner.vue.
 * Le composant vit dans le package partagé (source unique). Ce wrapper existe
 * pour que l'auto-import Nuxt (qui ne scanne pas node_modules) trouve le
 * composant sous son nom habituel. Karim 2026-06-21.
 */
import CampaignDonorsBanner from "@donoor/ui/campaign/CampaignDonorsBanner.vue";
</script>

<template>
  <CampaignDonorsBanner v-bind="($attrs as any)" />
</template>
